module.exports = __webpack_public_path__ + "static/media/22-en.bf497c62.svg";